export default {
  label: {
    no: 'transaction code',
    systemOrderNo: 'systemNo',
    balance: 'Balance',
    amount: 'transfer amount',
    confirmTime: 'update time',
    createTime: 'Creation time',
    from: 'pay in',
    id: 'Primary key id',
    message: 'Transfer message',
    status: 'status',
    to: 'payout',
    type: 'type'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/userTransaction.js